import React, { Component } from 'react'
import { gql, graphql } from 'react-apollo'
import _ from 'lodash'

import Color from 'helpers/Color'
import {
  Statistic,
  Loading,
  Grid,
  Notifications,
  Segment,
} from 'components/UI'
import BuildingChart from './BuildingChart'

class Overview extends Component {
  state = {
    sort: 'value',
  }

  render () {
    const {
      error,
      loading,
      buildings,
    } = this.props.data

    if (error) return <Notifications.Error message={error.message} />

    const averagePercent = _.round(_.meanBy(buildings, 'ratio'))
    const alertCount = _.sumBy(buildings, 'alertCount')

    return (
      <Grid>
        <Grid.Row>
          <Grid.Col desktopOnly />
          <Grid.Col width={2}>
            { loading ? <Loading /> : (
              <Statistic
                value={`${averagePercent || 0}%`}
                description='Radiators Reporting Data'
              />
            )}
          </Grid.Col>
          <Grid.Col width={2}>
            { loading ? <Loading /> : (
              <Statistic
                value={alertCount}
                description='Alerts'
                color={Color.red}
                link='/alerts'
              />
            )}
          </Grid.Col>
          <Grid.Col desktopOnly />
        </Grid.Row>
        <Grid.Row>
          <Grid.Col desktopOnly />
          <Grid.Col width={4}>
            <Segment centered>
              { loading ? <Loading /> : (
                <BuildingChart
                  history={this.props.history}
                  data={buildings}
                />
              )}
            </Segment>
          </Grid.Col>
          <Grid.Col desktopOnly />
        </Grid.Row>
      </Grid>
    )
  }
}

export default graphql(gql`
  query OverviewQuery {
    buildings(active: true) {
      id
      name
      temp
      ratio
      alertCount
    }
  }
`, {
  options: { notifyOnNetworkStatusChange: true },
})(Overview)



// WEBPACK FOOTER //
// ./src/components/Overview/Overview.jsx